module.exports = __webpack_public_path__ + "static/media/ctcMix.dc202df4.png";